import React from 'react';

import { makeStyles, Theme } from '@material-ui/core/styles';

import { Typography } from '../../atoms/Typography';

const useStyles = makeStyles((theme: Theme) => ({
  iconLineItem: {
    display: 'flex',
    flexFlow: 'row nowrap',
    marginBottom: theme.spacing(1),
    padding: theme.spacing(1, 0),
  },
  iconWrapper: {
    alignSelf: 'center',
    marginRight: theme.spacing(1.5),
    width: theme.spacing(2.5),
  },
  lineItem: {
    display: 'flex',
    flexFlow: 'column nowrap',
  },
}));

export type IconLineItemProps = {
  content: string | JSX.Element;
  icon: JSX.Element;
  label: string;
};

export function IconLineItem(props: IconLineItemProps): JSX.Element {
  const { content, icon, label } = props;

  const classes = useStyles();

  const lineItemContent =
    typeof content === 'string' ? <Typography>{content}</Typography> : content;

  return (
    <li className={classes.iconLineItem}>
      <div className={classes.iconWrapper}>{icon}</div>

      <div className={classes.lineItem}>
        <Typography variant="body2-secondary">{label}</Typography>

        {lineItemContent}
      </div>
    </li>
  );
}
